import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import { SoNetMailInfoResponse } from '@/types/api/mypage/soNetMailInfo';

/** So-netメール情報取得APIのURL */
const url = ApiUrl.Read.SONET_MAIL_INFO;

/**
 * So-netメール情報取得APIの呼び出しフック。
 * メールアドレスや利用状況の表示に必要な情報を取得する。
 *
 * @returns execute - API実行関数
 */
const useGetSoNetMailInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<SoNetMailInfoResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetSoNetMailInfo;
